import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: number): string {
  return new Intl.NumberFormat('ar-IQ', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPriceWithCurrency(amount: number): string {
  return `${formatPrice(amount)} د.ع`;
}

export const VEHICLE_LABELS: Record<string, { en: string; ar: string }> = {
  sedan: { en: 'Sedan', ar: 'سيدان' },
  suv: { en: 'SUV', ar: 'دفع رباعي' },
  large_suv: { en: 'Large SUV', ar: 'دفع رباعي كبير' },
};
